"use client";

import { dynamicChart } from "@/components/charts/dynamicChart";

export type { RcgDpSurgeProps } from "./RcgDpSurgeChart.impl";

export const RcgDpSurgeChart = dynamicChart(
  () => import("./RcgDpSurgeChart.impl").then((m) => m.RcgDpSurgeChart),
  300,
);
